export class Event {
  constructor(name) {
    this.currentIndex = 1;
    this.listeners = {};
    this.name = name;
  }

  addListener(callback, ctx, once = false) {
    const key = this.currentIndex.toString();
    this.listeners[key] = { callback, ctx, once };
    this.currentIndex += 1;
    return this.removeListener.bind(this, key);
  }

  removeListener(key) {
    delete this.listeners[key];
  }

  callListeners(...args) {
    Object.keys(this.listeners).forEach((key) => {
      const { callback, ctx, once } = this.listeners[key];
      callback.call(ctx, ...args);
      if (once) this.removeListener(key);
    });
  }
}
